import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#fff"
        d="m11.765 10.625-3.25-3.251a4.648 4.648 0 0 0 .848-2.693c0-1.25-.486-2.427-1.371-3.31A4.648 4.648 0 0 0 4.682 0a4.643 4.643 0 0 0-3.31 1.372A4.649 4.649 0 0 0 0 4.683c0 1.25.487 2.427 1.372 3.31a4.649 4.649 0 0 0 3.31 1.373c.98 0 1.911-.298 2.695-.854l3.248 3.25a.804.804 0 1 0 1.138-1.137h.002ZM4.682 8.279a3.596 3.596 0 1 1 .002-7.192 3.596 3.596 0 0 1-.002 7.192Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h12v12H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgComponent
